import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export default function RequiredFields() {

    const [modalIsOpen, setIsOpen] = React.useState(false);


    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    return (<>
        <Button color="primary" size="sm" onClick={openModal}><i className='bi bi-info-circle'></i>&nbsp; Required Fields</Button>
        <Modal backdrop centered size="lg"
            isOpen={modalIsOpen}
            toggle={() => closeModal()}
        >
            <ModalHeader toggle={() => closeModal()}>
                Required fields (default field names)
            </ModalHeader>
            <ModalBody>
                <ul>
                    <li><b>Name:</b>
                        <ul>
                            <li>fullname</li>
                            OR
                            <li>fname and lname</li>
                        </ul>
                    </li>
                    <li><b>Address:</b>
                        <ul>
                            <li>Street Address</li>
                            <ul>
                                <li>addr1</li>
                                OR
                                <li>addrnum, addrpredir, addrstreet, addrsuffix, addrpostdir, addrsectype, addrsecnum</li>
                            </ul>
                        </ul>
                        <ul>
                            <li>Region</li>
                            <ul>
                                <li>zip</li>
                                OR
                                <li> City and State
                                    <ul>
                                        <li>city</li>
                                        AND
                                        <li>state</li>
                                    </ul>
                                </li>
                                <li>lastline e.g. 'City, ST Zipcode'</li>
                            </ul>
                        </ul>
                    </li>
                </ul>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => closeModal()}>close</Button>
            </ModalFooter>
        </Modal>
    </>);
}
